import { isNarrowView } from '../utilities/index.js';

(function () {
  'use strict';

  // ========================
  // Constants
  // ========================
  const SELECTORS = {
    trigger: '.js-gnav-trigger',
    subList: '.subList',
    link: '.l-gnav__link',
    menuTrigger: '#js-menu-trigger',
    menuWrapper: '.l-gnav',
    header: '.l-header',
  };

  const CLASSES = {
    show: 'is-show',
    visible: 'is-visible',
    hover: 'is-hover',
    modalOpen: 'is-modal-open',
    open: 'is-open',
    initialized: 'js-initialized',
  };

  // ========================
  // Utilities
  // ========================
  const removeClassesFromElements = (selector, ...classes) => {
    document.querySelectorAll(selector).forEach((el) => {
      el.classList.remove(...classes);
    });
  };

  const resetSlideStyles = (el) => {
    el.style.removeProperty('height');
    el.style.removeProperty('transition');
  };

  const setSlideStyles = (el, height, duration) => {
    el.style.transition = `height ${duration}ms ease`;
    el.style.height = `${height}px`;
  };

  // ========================
  // Global Variables
  // ========================
  let currentMode = null;
  let resizeTimer = null;

  // ========================
  // Core Functions
  // ========================
  const resetGNavState = () => {
    const classSelector = [
      `.${CLASSES.visible}`,
      `.${CLASSES.open}`,
      `.${CLASSES.hover}`
    ].join(', ');
    
    const classNames = [
      CLASSES.visible,
      CLASSES.open,
      CLASSES.hover
    ];
    
    removeClassesFromElements(classSelector, ...classNames);
    
    document.body.classList.remove(CLASSES.modalOpen);
    document.body.style.top = '';
    document.querySelector(SELECTORS.menuWrapper).classList.remove(CLASSES.show);
  };

  const resetGNavTriggers = () => {
    resetGNavState();
    document.querySelectorAll(SELECTORS.trigger).forEach((el) => {
      const clone = el.cloneNode(true);
      el.parentNode.replaceChild(clone, el);
    });
  };

  const slideUp = (el, duration = 300) => {
    el.style.height = `${el.scrollHeight}px`;
    requestAnimationFrame(() => {
      setSlideStyles(el, 0, duration);
    });

    setTimeout(() => {
      resetSlideStyles(el);
      const item = el.closest(SELECTORS.trigger);
      item.classList.remove(CLASSES.open);
    }, duration);
  };

  const slideDown = (el, duration = 300) => {
    el.style.height = '0';
    const height = el.scrollHeight;
    const item = el.closest(SELECTORS.trigger);
    item.classList.add(CLASSES.open);

    requestAnimationFrame(() => {
      setSlideStyles(el, height, duration);
    });

    setTimeout(() => {
      resetSlideStyles(el);
    }, duration);
  };

  const addHoverListeners = (trigger, subList, link) => {
    trigger.addEventListener('mouseenter', () => {
      subList.classList.add(CLASSES.visible);
      link.classList.add(CLASSES.hover);
    });

    trigger.addEventListener('mouseleave', () => {
      subList.classList.remove(CLASSES.visible);
      link.classList.remove(CLASSES.hover);
    });
  };

  const initWideNav = () => {
    document.querySelectorAll(SELECTORS.trigger).forEach((trigger) => {
      const subList = trigger.querySelector(SELECTORS.subList);
      const link = trigger.querySelector(SELECTORS.link);
      if (!subList || !link) return;
      addHoverListeners(trigger, subList, link);
    });
  };

  const initNarrowNav = () => {
    const menuTrigger = document.querySelector(SELECTORS.menuTrigger);
    const menuWrapper = document.querySelector(SELECTORS.menuWrapper);
    const header = document.querySelector(SELECTORS.header);
    menuWrapper.classList.add(CLASSES.show);

    if (menuTrigger && !menuTrigger.classList.contains(CLASSES.initialized)) {
      menuTrigger.classList.add(CLASSES.initialized);
      let scrollY = 0;

      menuTrigger.addEventListener('click', () => {
        const isOpen = menuWrapper.classList.toggle(CLASSES.visible);
        header.classList.toggle(CLASSES.open);

        if (isOpen) {
          scrollY = window.scrollY;
          document.body.classList.add(CLASSES.modalOpen);
          document.body.style.top = `-${scrollY}px`;
        } else {
          document.body.classList.remove(CLASSES.modalOpen);
          document.body.style.top = '';
          window.scrollTo(0, scrollY);
        }
      });
    }

    document.querySelectorAll(SELECTORS.trigger).forEach((item) => {
      const link = item.querySelector(SELECTORS.link);
      const subList = item.querySelector(SELECTORS.subList);
      if (!link || !subList) return;

      link.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = item.classList.contains(CLASSES.open);
        if (isOpen) {
          slideUp(subList);
        } else {
          slideDown(subList);
        }
        link.classList.toggle(CLASSES.open);
      });
    });

    // アンカーリンクでメニューを閉じる
    document.querySelectorAll(`${SELECTORS.menuWrapper} a[href*="#"]`).forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        const targetId = anchor.hash;
        const isSamePage = window.location.pathname === anchor.pathname;
    
        // 同一ページ内のアンカーリンクのみ処理
        if (isSamePage && targetId && targetId !== '#') {
          const targetElement = document.querySelector(targetId);
          if (!targetElement) return;
    
          e.preventDefault();
    
          // メニューを閉じる
          const menuWrapper = document.querySelector(SELECTORS.menuWrapper);
          const header = document.querySelector(SELECTORS.header);
          menuWrapper.classList.remove(CLASSES.visible);
          header.classList.remove(CLASSES.open);
          document.body.classList.remove(CLASSES.modalOpen);
          document.body.style.top = '';
    
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });    
  };

  const initGNav = () => {
    const mode = isNarrowView() ? 'narrow' : 'wide';
    if (mode === currentMode) return;

    resetGNavTriggers();
    if (mode === 'wide') {
      initWideNav();
    } else {
      initNarrowNav();
    }
    currentMode = mode;
  };

  // ========================
  // Initialize
  // ========================
  initGNav();

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initGNav, 50);
  });
})();
